import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

export const useUpdateDocument = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({
			documentId,
			displayName,
			notes,
		}: {
			documentId: number;
			displayName?: string;
			notes?: string | null;
		}) => {
			return await EndpointsService.dataRetriever.updateDocument({
				documentId,
				body: {
					...(displayName !== undefined && { displayName }),
					...(notes !== undefined && { notes }),
				},
			});
		},
		onSuccess: (_data) => {
			// Invalidate and refetch documents data
			queryClient.invalidateQueries({ queryKey: ["documents"] });
		},
	});
};
